const translation = {
  daysInWeek: {
    Thu: 'Četrtek',
    Fri: 'Petek',
    Tue: 'Torek',
    Sun: 'Sonce',
    Wed: 'Sreda',
    Mon: 'Mon',
    Sat: 'Satelit',
  },
  months: {
    February: 'Februar',
    April: 'April',
    October: 'oktober',
    May: 'Maj',
    December: 'December',
    September: 'September',
    January: 'Januar',
    July: 'Julij',
    March: 'Marec',
    June: 'Junij',
    November: 'November',
    August: 'Avgust',
  },
  operation: {
    cancel: 'Prekliči',
    now: 'Zdaj',
    pickDate: 'Izberi datum',
    ok: 'V redu',
  },
  title: {
    pickTime: 'Izberi čas',
  },
  defaultPlaceholder: 'Izberi čas...',
}

export default translation
